import { useQuery } from "@tanstack/react-query";

import {
  TokenUsageResponse,
  type TokenUsageBucketSize,
} from "@oracus/shared/api/token-usage";

import { apiClient } from "./client.ts";

export interface TokenUsageParams {
  from?: string;
  to?: string;
  bucket?: TokenUsageBucketSize;
  repoId?: string;
  conversationId?: string;
  userId?: string;
  task?: string;
}

function buildQuery(params: TokenUsageParams): string {
  const sp = new URLSearchParams();
  if (params.from) sp.set("from", params.from);
  if (params.to) sp.set("to", params.to);
  if (params.bucket) sp.set("bucket", params.bucket);
  if (params.repoId) sp.set("repoId", params.repoId);
  if (params.conversationId) sp.set("conversationId", params.conversationId);
  if (params.userId) sp.set("userId", params.userId);
  if (params.task) sp.set("task", params.task);
  const qs = sp.toString();
  return qs ? `?${qs}` : "";
}

export function useTokenUsage(params: TokenUsageParams) {
  return useQuery({
    queryKey: ["token-usage", params],
    queryFn: () =>
      apiClient.get(
        `/api/admin/token-usage${buildQuery(params)}`,
        TokenUsageResponse,
      ),
    staleTime: 30_000,
  });
}
